import { DEALER_PERMISSIONS } from 'Utilities/consts';

import usePermission from './usePermission';

const useKycPermission = (): boolean => usePermission(DEALER_PERMISSIONS.KYC);

export default useKycPermission;
